
	/**
	 * @description
	 *  Modelo de un tipo de nota de CyR (cambio y reclamo), o NC (nota de
	 *	crédito), sobre un pedido.
	 *
	 * @see gigot-backend/Models/Orders/OrderEventType.cs
	 */

export class OrderEventType {

	public id: number;
	public type: string;

	/**
	 * @description
	 *	Construye un tipo de nota con una semántica vacía. Nótese que no es lo
	 *	mismo que construir un tipo de nota con valores por defecto. Las
	 *	reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un tipo de nota de CyR/NC vacía.
	 */
	public static empty(): OrderEventType {
		const orderEventType: OrderEventType = new OrderEventType();
		orderEventType.id = undefined;
		orderEventType.type = "";
		return orderEventType;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderEventType
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderEventType: OrderEventType): OrderEventType {
		if (!anemicOrderEventType) return undefined;
		const orderEventType: OrderEventType = OrderEventType.empty();
		orderEventType.id = anemicOrderEventType.id;
		orderEventType.type = anemicOrderEventType.type;
		return orderEventType;
	}
}
